import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import * as React from 'react';
import * as PropTypes from 'prop-types';

var TimeCell = function TimeCell(props) {
  var handleTime = function handleTime(e) {
    e.stopPropagation();
    props.onSelectTime(_parseInt(props.time, 10), props.type, e);
  };

  return /*#__PURE__*/React.createElement("li", {
    onClick: handleTime,
    className: props.className
  }, props.time);
};

TimeCell.propTypes = {
  className: PropTypes.string,
  time: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectTime: PropTypes.func,
  type: PropTypes.string
};
TimeCell.defaultProps = {
  className: '',
  time: '',
  type: 'hour',
  onSelectTime: function onSelectTime() {}
};
export default TimeCell;